import { initSentry } from './lib/sentry'; 
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from 'next-themes'
import App from './App.tsx'
import './index.css'
import { initAnalytics } from './lib/analytics'

// Initialize Sentry error tracking
initSentry(); 

// Initialize analytics
initAnalytics();

createRoot(document.getElementById("root")!).render(
  <ThemeProvider 
    attribute="class" 
    defaultTheme="charcoal-pro" 
    themes={['charcoal-pro', 'ivory-scholar', 'forest-study', 'cafe-mocha', 'royal-scholar', 'golden-scholar', 'rose-focus']}
    enableSystem={false}
    storageKey="studyforge-theme"
    disableTransitionOnChange={true}
  >
    <App />
  </ThemeProvider>
);
